"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var queryString = require("query-string");
function px2rem(pxNumber) {
    return pxNumber / 46.875 + "rem";
}
exports.px2rem = px2rem;
var checkTodayLessonType = function () {
    var day = new Date().getDay();
    switch (day) {
        case 1:
        case 3:
        case 5:
            return 'lesson';
        case 2:
        case 4:
        case 6:
            return 'exercise';
        default:
            return 'review';
    }
};
exports.checkTodayLessonType = checkTodayLessonType;
var StudentStatus;
(function (StudentStatus) {
    StudentStatus[StudentStatus["NOT_ENROLLED"] = 0] = "NOT_ENROLLED";
    StudentStatus[StudentStatus["WILL_START"] = 1] = "WILL_START";
    StudentStatus[StudentStatus["DAY_OFF"] = 2] = "DAY_OFF";
    StudentStatus[StudentStatus["NO_DATA"] = 3] = "NO_DATA";
    StudentStatus[StudentStatus["STUDYING"] = 4] = "STUDYING";
    StudentStatus[StudentStatus["ENDED"] = 5] = "ENDED";
})(StudentStatus = exports.StudentStatus || (exports.StudentStatus = {}));
var CountdownFormat;
(function (CountdownFormat) {
    CountdownFormat[CountdownFormat["HHMMSSCOLON"] = 0] = "HHMMSSCOLON";
    CountdownFormat[CountdownFormat["HHMMSS"] = 1] = "HHMMSS";
    CountdownFormat[CountdownFormat["DDHHMMSS"] = 2] = "DDHHMMSS";
    CountdownFormat[CountdownFormat["MMSS"] = 3] = "MMSS";
})(CountdownFormat = exports.CountdownFormat || (exports.CountdownFormat = {}));
function sortMomentIncrease(a, b) {
    if (a.isAfter(b)) {
        return 1;
    }
    if (a.isBefore(b)) {
        return -1;
    }
    return 0;
}
exports.sortMomentIncrease = sortMomentIncrease;
// 获取指定enrollments的最近开课的enrollments
function getWillReadyEnrollments(enrollments) {
    var nowDate = moment();
    var skuWillReadyEnrollments = enrollments.filter(function (enrollment) {
        return moment(enrollment.sku.start, 'YYYY-MM-DD').isAfter(nowDate);
    });
    // 将enrollments根据sku.start升序
    skuWillReadyEnrollments.sort(function (a, b) {
        if (moment(a.sku.start, 'YYYY-MM-DD').isAfter(moment(b.sku.start, 'YYYY-MM-DD'))) {
            return 1;
        }
        if (moment(a.sku.start, 'YYYY-MM-DD').isBefore(moment(b.sku.start, 'YYYY-MM-DD'))) {
            return -1;
        }
        return 0;
    });
    return skuWillReadyEnrollments;
}
exports.getWillReadyEnrollments = getWillReadyEnrollments;
// 获取指定enrollments中还没有结束上课的enrollments
function getIncompleteEnrollments(enrollments) {
    var nowDate = moment();
    var skusWillDoneEnrollments = enrollments.filter(function (enrollment) {
        return moment(enrollment.sku.end, 'YYYY-MM-DD').isAfter(nowDate);
    });
    return skusWillDoneEnrollments;
}
exports.getIncompleteEnrollments = getIncompleteEnrollments;
var distinct = function (arr) {
    return arr.filter(function (item, index, array) { return array.indexOf(item) === index; });
};
exports.distinct = distinct;
var filterArray = function (array) {
    return array.filter(function (item) { return item; });
};
exports.filterArray = filterArray;
function reduceBy(list, by, cb, defaultRtn) {
    return list.reduce(function (acc, item, i) {
        var val = item[by];
        return cb(acc, val, item, i);
    }, defaultRtn);
}
function createMapBy(list, by) {
    return reduceBy(list, by, function (map, val, item) {
        var group = map.get(val) || [];
        group.push(item);
        map.set(val, group);
        return map;
    }, new Map());
}
exports.createMapBy = createMapBy;
function sumBy(list, by) {
    return sum(list.map(function (val) { return val[by]; }));
}
exports.sumBy = sumBy;
function averageBy(list, by) {
    return average(list.map(function (val) { return val[by]; }));
}
exports.averageBy = averageBy;
function sum(list) {
    return list.reduce(function (acc, val) { return acc + Number(val); }, 0);
}
exports.sum = sum;
function average(list) {
    var vals = list.map(function (val) { return Number(val); }).filter(function (val) { return val; });
    return vals.length ? sum(vals) / vals.length : 0;
}
exports.average = average;
function calculateIntPrice(price) {
    return (Math.round(price * 100) / 100).toFixed(2);
}
exports.calculateIntPrice = calculateIntPrice;
function removeZeroOfNumberAfterPoint(num) {
    return Math.round(num * 100) / 100;
}
exports.removeZeroOfNumberAfterPoint = removeZeroOfNumberAfterPoint;
function addZeroInFrontOfNumber(value) {
    if (value < 10) {
        return "0" + value;
    }
    return String(value);
}
exports.addZeroInFrontOfNumber = addZeroInFrontOfNumber;
function getCountdownFormat(countdown, format) {
    if (format === void 0) { format = CountdownFormat.HHMMSSCOLON; }
    var hour = Math.floor(countdown / 1000 / 60 / 60);
    var minute = Math.floor((countdown / 1000 / 60) % 60);
    var second = Math.floor((countdown / 1000) % 60);
    if (format === CountdownFormat.HHMMSS) {
        return addZeroInFrontOfNumber(hour) + "\u65F6" + addZeroInFrontOfNumber(minute) + "\u5206" + addZeroInFrontOfNumber(second) + "\u79D2";
    }
    if (format === CountdownFormat.DDHHMMSS) {
        var day = Math.floor(countdown / 1000 / 60 / 60 / 24);
        if (day === 0) {
            return addZeroInFrontOfNumber(hour) + "\u65F6" + addZeroInFrontOfNumber(minute) + "\u5206" + addZeroInFrontOfNumber(second) + "\u79D2";
        }
        return addZeroInFrontOfNumber(day) + "\u5929" + addZeroInFrontOfNumber(hour % 24) + "\u65F6" + addZeroInFrontOfNumber(minute) + "\u5206" + addZeroInFrontOfNumber(second) + "\u79D2";
    }
    if (format === CountdownFormat.MMSS) {
        if (hour === 0) {
            return addZeroInFrontOfNumber(minute) + "\u5206" + addZeroInFrontOfNumber(second) + "\u79D2";
        }
        return addZeroInFrontOfNumber(hour) + "\u65F6" + addZeroInFrontOfNumber(minute) + "\u5206" + addZeroInFrontOfNumber(second) + "\u79D2";
    }
    return addZeroInFrontOfNumber(hour) + ":" + addZeroInFrontOfNumber(minute) + ":" + addZeroInFrontOfNumber(second);
}
exports.getCountdownFormat = getCountdownFormat;
function validatePhoneFormat(phoneNumber) {
    var trimmedPhoneNumber = trimPhoneNumber(phoneNumber);
    var phoneReg = /^1\d{10}$/;
    return phoneReg.test(trimmedPhoneNumber);
}
exports.validatePhoneFormat = validatePhoneFormat;
function trimPhoneNumber(phoneNumber) {
    if (phoneNumber === void 0) { phoneNumber = ''; }
    return phoneNumber.replace(/\s/g, '');
}
exports.trimPhoneNumber = trimPhoneNumber;
function checkIsToday(cachedTimestamp) {
    var today = new Date();
    var todayDate = today.getDate();
    var cachedDate = new Date(cachedTimestamp).getDate();
    return todayDate === cachedDate;
}
exports.checkIsToday = checkIsToday;
function appendQueryString(queryStr, paramObj) {
    if (queryStr.split('?').length > 2) {
        throw new Error('function "appendQueryString" parameter "queryStr" error!');
    }
    if (Object.keys(paramObj).length === 0) {
        return queryStr;
    }
    if (queryStr.indexOf('?') === -1) {
        var paramString = queryString.stringify(paramObj);
        return queryStr + "?" + paramString;
    }
    var _a = queryString.parseUrl(queryStr), preQueryStr = _a.url, subQueryStr = _a.query;
    var newParamsObj = Object.assign(subQueryStr, paramObj);
    var newQueryString = queryString.stringify(newParamsObj);
    return preQueryStr + "?" + newQueryString;
}
exports.appendQueryString = appendQueryString;
function nameMask(name) {
    if (!name) {
        return name;
    }
    var chars = name.split('');
    if (chars.length == 1) {
        return name;
    }
    if (chars.length == 2) {
        return name.replace(name.substring(0, 1), '*');
    }
    if (chars.length > 2) {
        var replaceStr = chars.length < 6 ? '*'.repeat(chars.length - 2) : '****';
        return name.replace(name.substring(1, chars.length - 1), replaceStr);
    }
    return '-';
}
exports.nameMask = nameMask;
function maskString(text, start, end, maskMark) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = text.length; }
    if (maskMark === void 0) { maskMark = '*'; }
    if (start > end) {
        return text;
    }
    var textPartOne = text.substr(0, start);
    var textPartTwo = text.substr(end, text.length);
    var maskPart = maskMark.repeat(end - start);
    var maskedString = "" + textPartOne + maskPart + textPartTwo;
    return maskedString;
}
exports.maskString = maskString;
//# sourceMappingURL=unit.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/utils/unit.js
// module id = 1042
// module chunks = 0